import React, {useEffect} from "react"
import {Route, match as Match} from "react-router-dom"
import qs from "qs"

import adminTracking from "@irati-tracking/admin"
import {IndexRedirect, NestedRoute} from "@irati/utils/history/routing"

import {HubViews} from "@irati-tracking/admin/admin"
import AutomationHome from "../containers/Automation"
import AutomationCreate from "../containers/Automation/Create"
import AutomationEdit from "../containers/Automation/Edit"
import {AUTOMATION_CREATE, AUTOMATION_EDIT, AUTOMATION_LIST} from "./routeConfig"
import {useFlexiPointsMigrationRedirect} from "@irati/wallet/hooks/flexiMigrationRedirect"

interface Props {
  match: Match
}

const Automation: React.FC<Props> = (props) => {
  const {match} = props
  useFlexiPointsMigrationRedirect()
  useEffect(() => {
    const query = qs.parse(window.location.search.replace("?", ""))
    adminTracking.navigationHubView(query.source ? "deeplink" : "navigation", HubViews.AUTOMATION)
  }, [])
  return (
    <Route
      path={match.url}
      render={() => (
        <>
          <NestedRoute match={match.url} path={AUTOMATION_LIST} exact component={AutomationHome} />
          <NestedRoute match={match.url} path={AUTOMATION_CREATE} component={AutomationCreate} />
          <NestedRoute match={match.url} path={AUTOMATION_EDIT} component={AutomationEdit} />
          <IndexRedirect match={match.url} to={AUTOMATION_LIST} title="Admin Automation" />
        </>
      )}
    />
  )
}

export default Automation
